import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Navbar from '../components/Navbar/Navbar';

// Importa tus imágenes
import FacebookIcon from '../img/facebook.svg';
import InstagramIcon from '../img/instagram.svg';
import Youtube from '../img/youtube.svg';
import GalleryImage1 from '../img/about/1.jpg';
import GalleryImage2 from '../img/about/2.jpg';
import GalleryImage3 from '../img/about/3.jpg';

const About = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const socialMedia = [
        { icon: FacebookIcon, alt: 'Facebook', link: '#' },
        { icon: InstagramIcon, alt: 'Instagram', link: '#' },
        { icon: Youtube, alt: 'Youtube', link: '#' }
    ];

    const galleryImages = [
        GalleryImage1,
        GalleryImage2,
        GalleryImage3
    ];

    return (
        <Box sx={{ backgroundColor: '#313131', minHeight: '100vh' }}>
            <Navbar />

            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                minHeight: 'calc(100vh - 64px)',
                p: isMobile ? 2 : 6,
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Sección de texto - Aumentado el padding izquierdo */}
                <Box sx={{
                    width: isMobile ? '100%' : '50%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    pr: isMobile ? 0 : 4,
                    mb: isMobile ? 4 : 0,
                    position: 'relative',
                    pl: isMobile ? 0 : '100px' // Aumentado de 6 a 100px
                }}>
                    {/* Línea neon vertical movida más a la derecha */}
                    <Box sx={{
                        position: 'absolute',
                        left: isMobile ? 20 : '80px', // Aumentado de 40 a 80px
                        top: 0,
                        height: '600px',
                        width: '6px',
                        backgroundColor: '#EBC848',
                        boxShadow: '0 0 10px #EBC848, 0 0 20px #EBC848',
                        zIndex: 1,
                        display: isMobile ? 'none' : 'block'
                    }} />

                    {/* Redes sociales movidas más a la izquierda */}
                    {!isMobile && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            position: 'absolute',
                            left: '0px', // Mantenido a la izquierda
                            top: '60%',
                            transform: 'translateY(-45%)',
                            zIndex: 2
                        }}>
                            {socialMedia.map((social, index) => (
                                <Box
                                    component="img"
                                    key={index}
                                    src={social.icon}
                                    alt={social.alt}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            filter: 'drop-shadow(0 0 5px #EBC848)'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}

                    <Typography variant="h1" sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 700,
                        color: '#EBC848',
                        fontSize: isSmallMobile ? '2rem' : isMobile ? '2.5rem' : '3.5rem',
                        lineHeight: 1.2,
                        mb: 4,
                        textTransform: 'uppercase',
                        textAlign: isMobile ? 'center' : 'left',
                        position: 'relative'
                    }}>
                        ¿QUIENES SOMOS?
                    </Typography>

                    <Typography variant="body1" sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 400,
                        color: 'white',
                        fontSize: isMobile ? '0.9rem' : '1.1rem',
                        lineHeight: 1.6,
                        textAlign: isMobile ? 'center' : 'left',
                        mb: 1
                    }}>
                        Somos una empresa especializada en energía solar, brindamos soluciones reales a nuestros clientes mediante la aplicación del uso de la energía solar, atendiendo y resolviendo las necesidades de tu hogar, empresa o industria.
                    </Typography>

                    <Typography variant="body1" sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 400,
                        color: 'white',
                        fontSize: isMobile ? '0.9rem' : '1.1rem',
                        lineHeight: 1.6,
                        textAlign: isMobile ? 'center' : 'left',
                        mb: 1
                    }}>
                        Todos nuestros proyectos son personalizados y adecuados a sus necesidades con tecnología avanzada, productos certificados y con una excelente calidad. Desarrollamos proyectos ajustados a la necesidad de cualquier tipo de cliente.
                    </Typography>

                    <Typography variant="body1" sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 400,
                        color: 'white',
                        fontSize: isMobile ? '0.9rem' : '1.1rem',
                        lineHeight: 1.6,
                        textAlign: isMobile ? 'center' : 'left'
                    }}>
                        Instalamos la mejor y más reciente tecnología del mercado con productos certificados y con altos estándares en la construcción, llevando a nuestros clientes la mejor solución que les permite gozar de una mejor calidad de vida para ellos y para su familia, así como aumentar sus procesos comerciales ante la tendencia del aumento de los precios de la energía eléctrica. Con Dyme Energy ahorras energía y con ello contribuyes al medio ambiente.
                    </Typography>

                    {/* Redes sociales - Versión móvil */}
                    {isMobile && (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 4,
                            mt: 4
                        }}>
                            {socialMedia.map((social, index) => (
                                <Box
                                    component="img"
                                    key={index}
                                    src={social.icon}
                                    alt={social.alt}
                                    sx={{
                                        width: 35,
                                        height: 35,
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                            filter: 'drop-shadow(0 0 5px #EBC848)'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                </Box>

                {/* Galería hexagonal */}
                <Box sx={{
                    width: isMobile ? '100%' : '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    minHeight: isMobile ? '500px' : 'auto',
                    mt: isMobile ? 4 : 0
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        gap: isMobile ? 4 : 6
                    }}>
                        {/* Imagen superior central */}
                        <Box sx={{
                            width: 260,
                            height: 240,
                            clipPath: 'polygon(50% 0%, 90% 25%, 90% 75%, 50% 100%, 10% 75%, 10% 25%)',
                            backgroundColor: '#EBC848',
                            boxShadow: '0 0 20px #EBC848',
                            padding: '8px',
                            animation: 'neonPulse 4.5s infinite',
                            position: 'relative',
                            zIndex: 2
                        }}>
                            <Box
                                component="img"
                                src={galleryImages[0]}
                                alt="Galería 1"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    clipPath: 'inherit'
                                }}
                            />
                        </Box>

                        {/* Fila inferior con dos imágenes */}
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: isMobile ? 2 : 4,
                            mt: -10
                        }}>
                            <Box sx={{
                                width: 260,
                                height: 240,
                                position: 'relative',
                                clipPath: 'polygon(50% 0%, 90% 25%, 90% 75%, 50% 100%, 10% 75%, 10% 25%)',
                                backgroundColor: '#EBC848',
                                padding: '8px',
                                boxShadow: '0 0 20px #EBC848, 0 0 40px #EBC848',
                                animation: 'neonPulse 4s infinite alternate',
                                overflow: 'hidden',
                                zIndex: 2
                            }}>
                                <Box
                                    component="img"
                                    src={galleryImages[1]}
                                    alt="Galería 2"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        clipPath: 'inherit'
                                    }}
                                />
                            </Box>

                            <Box sx={{
                                width: 260,
                                height: 240,
                                position: 'relative',
                                clipPath: 'polygon(50% 0%, 90% 25%, 90% 75%, 50% 100%, 10% 75%, 10% 25%)',
                                padding: '8px',
                                backgroundColor: '#EBC848',
                                boxShadow: '0 0 20px #EBC848, 0 0 40px #EBC848',
                                animation: 'neonPulse 4s infinite alternate',
                                overflow: 'hidden',
                                zIndex: 2
                            }}>
                                <Box
                                    component="img"
                                    src={galleryImages[2]}
                                    alt="Galería 3"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        clipPath: 'inherit'
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Animación de neon */}
            <style>{`
        @keyframes neonPulse {
          0%, 100% {
            box-shadow: 0 0 10px #EBC848, 0 0 20px #EBC848;
          }
          50% {
            box-shadow: 0 0 15px #EBC848, 0 0 30px #EBC848;
          }
        }
      `}</style>
        </Box>
    );
};

export default About;